import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Declare gtag function for TypeScript
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (
      command: string,
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void;
  }
}

const GA_MEASUREMENT_ID = "G-KCQCXWJLYH";

/**
 * GoogleAnalytics component that tracks page views on route changes
 * This should be added once in your App component
 */
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Only track if gtag is available (script loaded)
    if (typeof window.gtag === "function") {
      window.gtag("config", GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
}


